import { render, staticRenderFns } from "./TeachersAddTabAccount.vue?vue&type=template&id=591a0b84"
import script from "./TeachersAddTabAccount.vue?vue&type=script&lang=js"
export * from "./TeachersAddTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports